import React, { useState } from 'react'
import { 
    // Layout, 
    Menu, 
    Row, 
    Col, 
    Image, 
    Modal,
    Button,
} from 'antd';
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import HeaderImage from "../../Assets/alta_logo.png"
import {
    // MenuFoldOutlined,
    // MenuUnfoldOutlined,
    CloseOutlined,
    UnorderedListOutlined,
} from '@ant-design/icons';
import { 
    Gite, 
    AccountBox, 
    Badge,  
    Person,
    StackedBarChart,
    ReceiptLong,  
    MeetingRoom,
} from '@mui/icons-material';
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { refreshPage } from '../../Utils/Common';
import { logout } from "../../Utils/api/Auth";
import toast from 'react-hot-toast';
const { SubMenu } = Menu;

function Navbar(props){
    const navigate = useNavigate();
    const [isHovered, setIsHovered] = useState(false);
    const [subMenu, setSubMenu] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [
        modal, 
        contextHolder
    ] = Modal.useModal();

    const toggleCollapsed = () => {
      setIsHovered(!isHovered);
    };

    async function handleLogout() {
        setIsLoading(true);
        const response = await logout();
        if (response.data){
           localStorage.removeItem('token');
            localStorage.removeItem('user_id');
            localStorage.removeItem('full_name');
            localStorage.removeItem('role_id');
            localStorage.removeItem('role_name');
            localStorage.removeItem('token_expiry');
            toast.error(response?.data?.message)
            setTimeout(()=>{
            navigate("/");
            refreshPage();
            }, 1000)
          } else {
            toast.error(response?.error?.message)
          }
        
        setIsLoading(false);
      }
    
    const confirm = () => {
        modal.confirm({
          title: "Are you sure you want to logout?",
          icon: <ExclamationCircleOutlined />,
          content: "",
          okButtonProps: { isLoading },
          okText: "Logout",
          cancelText: "Cancel",
          onOk: handleLogout,
        });
    };

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleToggleSub = (key) => {
        setSubMenu((prevOpenKeys) =>
          prevOpenKeys.includes(key) ? prevOpenKeys.filter((k) => k !== key) : [...prevOpenKeys, key]
        );
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
        setSubMenu('')
    };
    // const handleSubEnter = (sub_menu) => {
    //     setSubIsHovered(true);
    //     setSubMenu(sub_menu)
    // };

    // const handleSubLeave = () => {
    //     setSubIsHovered(false);
    //     setSubMenu('')
    // };
    // const handleMenuSelect = (key) => {
    //     setActiveTab(key);
    // };
    return (
        <>
            <Row className='toggle-navbar'>
                <Col span={24} align='right'>
                    <Button
                        type="primary"
                        onClick={toggleCollapsed}
                        className={isHovered ? 'm-1 toggle-btn cancel-btn' : 'm-1 toggle-btn'}
                    >
                        {isHovered ? <CloseOutlined/> : <UnorderedListOutlined />}
                    </Button>
                </Col>
            </Row>
            <div 
                className={isHovered ? 'navbar-container-hovered responsive-overflow-y' : 'navbar-container navbar-page responsive-overflow-y'}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <Row className='mb-2' style={{background: 'var(--dominant-color)'}}>
                    <Col span={24} className='center'>
                        <Image
                            width="40%" 
                            height="auto" 
                            src={HeaderImage}
                            alt="login-image"
                            preview={false}
                            // className='mt-4 mb-3'
                        />
                    </Col>
                </Row>
                <Row 
                    className={isHovered ? 'overflow-y responsive-overflow-y nav-height' : 'nav-height overflow'}
                >
                    <Col span={24}>
                        <Menu
                            mode="inline"
                            selectedKeys={props.navKey ? [props.navKey] : []}
                            openKeys={subMenu}
                            inlineCollapsed={!isHovered}
                            className='navbar-menu'
                        >
                            <SubMenu 
                                key="modified_stableford" 
                                icon={<Gite />} 
                                title="Modified Stableford"  
                                onTitleClick={() => handleToggleSub('modified_stableford')}
                            >
                                <Menu.Item key="invitational_nav" className='center'>
                                    <Link className='link-container' to="/invitational"><span>The View Invitational</span></Link>
                                </Menu.Item>
                                <Menu.Item key="three_to_count_nav">
                                    <Link className='link-container' to="/fourman"><span>4-Man Team, 3 to Count</span></Link>
                                </Menu.Item>
                            </SubMenu>  
                            <SubMenu 
                                key="molave_point_system" 
                                icon={<StackedBarChart />} 
                                title="Molave Point System"  
                                onTitleClick={() => handleToggleSub('molave_point_system')}
                            >
                                <Menu.Item key="fun_golf_nav">
                                    <Link className='link-container' to="/fun-golf"><span>Fun Golf</span></Link>
                                </Menu.Item>
                                <Menu.Item key="best_ball_nav">
                                    <Link className='link-container' to="/best-ball"><span>2-Man Best Ball</span></Link>
                                </Menu.Item>
                            </SubMenu>
                            <SubMenu
                                key="system_thirtysix"
                                icon={<Badge />}
                                title="System-36"
                                onTitleClick={() => handleToggleSub('system_thirtysix')}
                            >
                                <Menu.Item key="system_36_individual_nav" >
                                    <Link className='link-container' to="/system36individual"><span>Individual</span></Link>
                                </Menu.Item>
                                <Menu.Item key="system_36_team_nav" >
                                    <Link className='link-container' to="/system36team"><span>Team</span></Link>
                                </Menu.Item>
                            </SubMenu>  
                            <Menu.Item key="individual_strokeplay" icon={<Person />} className='center'>
                            <Link className='link-container' to="/individualstrokeplay"><span>Individual Strokeplay</span></Link>
                            </Menu.Item>
                            <SubMenu 
                                key="fiesta_scramble" 
                                icon={<ReceiptLong />} 
                                title="Fiesta Scramble" 
                                onTitleClick={() => handleToggleSub('fiesta_scramble')}
                            >
                                <Menu.Item key="two_man">
                                    <Link className='link-container' to="/billing"><span>2-Man</span></Link>
                                </Menu.Item>
                                <Menu.Item key="three_man">
                                    <Link className='link-container' to="/owner-billing"><span>3-Man</span></Link>
                                </Menu.Item>
                            </SubMenu>  
                            <Menu.Item key="user_nav" icon={<AccountBox />} className='center'>
                                <Link className='link-container' to="/user"><span>User</span></Link>
                            </Menu.Item>
                            <Menu.Item 
                                key="login" 
                                icon={<MeetingRoom className='logout-icon'/>} 
                                onClick={confirm} 
                                className='center logout-button' 
                                align='bottom'
                            >
                                <span>Logout</span>
                            </Menu.Item>
                            {contextHolder}
                        </Menu>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default Navbar
